module.exports = __webpack_public_path__ + "static/img/media_interview.e54dc5ec.png";